<div class="fast-checkin-duration-container">
  <div class="content-wrapper mt-4">
    <!-- <div class="mb-4">{{ 'i18n.domain.pay-till-now.pay-till-now-text' | translate }}</div> -->
    <div class="form-row row">
      <div class="form-group col-md-12">
        <div class="d-flex justify-content-between">
          <span class="text-muted">{{ 'i18n.shared.fields.zone' | translate }}</span>
          <strong>{{ zoneInfo?.name }}</strong>
        </div>
      </div>
    </div>
    <div class="form-row row">
      <div class="form-group col-md-12">
        <div class="d-flex justify-content-between">
          <span class="text-muted">{{ 'i18n.shared.fields.control-plate' | translate }}</span>
          <strong>{{ controlPlate }}</strong>
        </div>
      </div>
    </div>
    <div class="form-row row">
      <div class="form-group col-md-12">
        <div class="d-flex justify-content-between">
          <span class="text-muted">{{ 'i18n.domain.pay-till-now.total-parking-duration' | translate }}</span>
          <strong>{{ totalParkingDuration }}</strong>
        </div>
      </div>
    </div>
    @if (alreadyPaidParkingDuration) {
      <div class="form-row row">
        <div class="form-group col-md-12">
          <div class="d-flex justify-content-between">
            <span class="text-muted">{{ 'i18n.domain.pay-till-now.already-paid-parking-duration' | translate }}</span>
            <strong>{{ alreadyPaidParkingDuration }}</strong>
          </div>
        </div>
      </div>
    }

    <div class="form-row row">
      <div class="form-group col-md-12">
        <div class="d-flex justify-content-between">
          <span class="text-muted">{{ 'i18n.domain.fast-checkin.calculated-price' | translate }}</span>
          <strong class="text-primary">{{ priceWithCurrency }}</strong>
        </div>
        @if(hasFallbackPrice) {
          <small class="text-muted">
            {{ 'i18n.domain.fast-checkin.fallback-price-info' | translate: { param: normalPriceWithCurrency } }}
          </small>
        }
      </div>
    </div>

    @if(showReadyToLeaveMessage) {
      <div class="alert alert-success text-center" role="alert">
        {{ 'i18n.domain.pay-till-now.clear-for-departure' | translate: { timestamp: readyToLeaveTimestamp } }}
      </div>
    }

    @if(showError) {
      <div class="alert alert-danger text-center" role="alert">
        {{ errorMessage | translate }}
      </div>
    }

    @if(hasOffense) {
      <div class="alert alert-danger" role="alert">
        {{ 'i18n.domain.parker-registration.ParkerRegistrationOffense.' + offenseType | translate }}
      </div>
    }

    <div class="button-container">
      <div class="form-row row">
        <div class="form-group col-6">
          <div class="d-grid">
            <button type="button" class="btn btn-outline-primary" (click)="back.emit()" [disabled]="showReadyToLeaveMessage">
              {{ 'i18n.shared.back' | translate }}
            </button>
          </div>
        </div>
        <div class="form-group col-6">
          <div class="d-grid">
            <button type="button" class="btn btn-primary" (click)="onPayNow()" [disabled]="showError || showReadyToLeaveMessage">
              {{ 'i18n.domain.pay-till-now.pay-now' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
